import { FirebaseApp, initializeApp } from 'firebase/app'

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

let app: FirebaseApp | undefined

export const getFirebaseApp = (): FirebaseApp => {
    if (! app) {
        app = initializeApp(firebaseConfig)
    }

    return app
}
